/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AiCatalogRouteImport } from './routes/ai-catalog'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as BlueprintsRouteImport } from './routes/blueprints'
import { Route as McpsRouteImport } from './routes/mcps'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as ThemeTokensRouteImport } from './routes/theme-tokens'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as DeploymentsFastSwitchRouteImport } from './routes/deployments.fast-switch'
import { Route as DeploymentsNewRouteImport } from './routes/deployments.new'
import { Route as DeploymentsObservabilityRouteImport } from './routes/deployments.observability'
import { Route as DeploymentsOverviewRouteImport } from './routes/deployments.overview'
import { Route as PlaygroundChar123IdChar125RouteImport } from './routes/playground.{-$id}'
import { Route as PlatformSecurityApiKeysRouteImport } from './routes/platform/security/api-keys'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AiCatalogRoute = AiCatalogRouteImport.update({
  id: '/ai-catalog',
  path: '/ai-catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysRoute = ApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const BlueprintsRoute = BlueprintsRouteImport.update({
  id: '/blueprints',
  path: '/blueprints',
  getParentRoute: () => rootRouteImport,
} as any)
const McpsRoute = McpsRouteImport.update({
  id: '/mcps',
  path: '/mcps',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ThemeTokensRoute = ThemeTokensRouteImport.update({
  id: '/theme-tokens',
  path: '/theme-tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentsFastSwitchRoute = DeploymentsFastSwitchRouteImport.update({
  id: '/deployments/fast-switch',
  path: '/deployments/fast-switch',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentsNewRoute = DeploymentsNewRouteImport.update({
  id: '/deployments/new',
  path: '/deployments/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentsObservabilityRoute =
  DeploymentsObservabilityRouteImport.update({
    id: '/deployments/observability',
    path: '/deployments/observability',
    getParentRoute: () => rootRouteImport,
  } as any)
const DeploymentsOverviewRoute = DeploymentsOverviewRouteImport.update({
  id: '/deployments/overview',
  path: '/deployments/overview',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundChar123IdChar125Route =
  PlaygroundChar123IdChar125RouteImport.update({
    id: '/playground/{-$id}',
    path: '/playground/{-$id}',
    getParentRoute: () => rootRouteImport,
  } as any)
const PlatformSecurityApiKeysRoute = PlatformSecurityApiKeysRouteImport.update({
  id: '/platform/security/api-keys',
  path: '/platform/security/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/ai-catalog': typeof AiCatalogRoute
  '/api-keys': typeof ApiKeysRoute
  '/blueprints': typeof BlueprintsRoute
  '/mcps': typeof McpsRoute
  '/projects': typeof ProjectsRoute
  '/theme-tokens': typeof ThemeTokensRoute
  '/usage': typeof UsageRoute
  '/deployments/fast-switch': typeof DeploymentsFastSwitchRoute
  '/deployments/new': typeof DeploymentsNewRoute
  '/deployments/observability': typeof DeploymentsObservabilityRoute
  '/deployments/overview': typeof DeploymentsOverviewRoute
  '/playground/{-$id}': typeof PlaygroundChar123IdChar125Route
  '/platform/security/api-keys': typeof PlatformSecurityApiKeysRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/ai-catalog': typeof AiCatalogRoute
  '/api-keys': typeof ApiKeysRoute
  '/blueprints': typeof BlueprintsRoute
  '/mcps': typeof McpsRoute
  '/projects': typeof ProjectsRoute
  '/theme-tokens': typeof ThemeTokensRoute
  '/usage': typeof UsageRoute
  '/deployments/fast-switch': typeof DeploymentsFastSwitchRoute
  '/deployments/new': typeof DeploymentsNewRoute
  '/deployments/observability': typeof DeploymentsObservabilityRoute
  '/deployments/overview': typeof DeploymentsOverviewRoute
  '/playground/{-$id}': typeof PlaygroundChar123IdChar125Route
  '/platform/security/api-keys': typeof PlatformSecurityApiKeysRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/ai-catalog': typeof AiCatalogRoute
  '/api-keys': typeof ApiKeysRoute
  '/blueprints': typeof BlueprintsRoute
  '/mcps': typeof McpsRoute
  '/projects': typeof ProjectsRoute
  '/theme-tokens': typeof ThemeTokensRoute
  '/usage': typeof UsageRoute
  '/deployments/fast-switch': typeof DeploymentsFastSwitchRoute
  '/deployments/new': typeof DeploymentsNewRoute
  '/deployments/observability': typeof DeploymentsObservabilityRoute
  '/deployments/overview': typeof DeploymentsOverviewRoute
  '/playground/{-$id}': typeof PlaygroundChar123IdChar125Route
  '/platform/security/api-keys': typeof PlatformSecurityApiKeysRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/ai-catalog'
    | '/api-keys'
    | '/blueprints'
    | '/mcps'
    | '/projects'
    | '/theme-tokens'
    | '/usage'
    | '/deployments/fast-switch'
    | '/deployments/new'
    | '/deployments/observability'
    | '/deployments/overview'
    | '/playground/{-$id}'
    | '/platform/security/api-keys'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/ai-catalog'
    | '/api-keys'
    | '/blueprints'
    | '/mcps'
    | '/projects'
    | '/theme-tokens'
    | '/usage'
    | '/deployments/fast-switch'
    | '/deployments/new'
    | '/deployments/observability'
    | '/deployments/overview'
    | '/playground/{-$id}'
    | '/platform/security/api-keys'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/ai-catalog'
    | '/api-keys'
    | '/blueprints'
    | '/mcps'
    | '/projects'
    | '/theme-tokens'
    | '/usage'
    | '/deployments/fast-switch'
    | '/deployments/new'
    | '/deployments/observability'
    | '/deployments/overview'
    | '/playground/{-$id}'
    | '/platform/security/api-keys'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AiCatalogRoute: typeof AiCatalogRoute
  ApiKeysRoute: typeof ApiKeysRoute
  BlueprintsRoute: typeof BlueprintsRoute
  McpsRoute: typeof McpsRoute
  ProjectsRoute: typeof ProjectsRoute
  ThemeTokensRoute: typeof ThemeTokensRoute
  UsageRoute: typeof UsageRoute
  DeploymentsFastSwitchRoute: typeof DeploymentsFastSwitchRoute
  DeploymentsNewRoute: typeof DeploymentsNewRoute
  DeploymentsObservabilityRoute: typeof DeploymentsObservabilityRoute
  DeploymentsOverviewRoute: typeof DeploymentsOverviewRoute
  PlaygroundChar123IdChar125Route: typeof PlaygroundChar123IdChar125Route
  PlatformSecurityApiKeysRoute: typeof PlatformSecurityApiKeysRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-catalog': {
      id: '/ai-catalog'
      path: '/ai-catalog'
      fullPath: '/ai-catalog'
      preLoaderRoute: typeof AiCatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys': {
      id: '/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof ApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blueprints': {
      id: '/blueprints'
      path: '/blueprints'
      fullPath: '/blueprints'
      preLoaderRoute: typeof BlueprintsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcps': {
      id: '/mcps'
      path: '/mcps'
      fullPath: '/mcps'
      preLoaderRoute: typeof McpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/theme-tokens': {
      id: '/theme-tokens'
      path: '/theme-tokens'
      fullPath: '/theme-tokens'
      preLoaderRoute: typeof ThemeTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments/fast-switch': {
      id: '/deployments/fast-switch'
      path: '/deployments/fast-switch'
      fullPath: '/deployments/fast-switch'
      preLoaderRoute: typeof DeploymentsFastSwitchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments/new': {
      id: '/deployments/new'
      path: '/deployments/new'
      fullPath: '/deployments/new'
      preLoaderRoute: typeof DeploymentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments/observability': {
      id: '/deployments/observability'
      path: '/deployments/observability'
      fullPath: '/deployments/observability'
      preLoaderRoute: typeof DeploymentsObservabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployments/overview': {
      id: '/deployments/overview'
      path: '/deployments/overview'
      fullPath: '/deployments/overview'
      preLoaderRoute: typeof DeploymentsOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground/{-$id}': {
      id: '/playground/{-$id}'
      path: '/playground/{-$id}'
      fullPath: '/playground/{-$id}'
      preLoaderRoute: typeof PlaygroundChar123IdChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/security/api-keys': {
      id: '/platform/security/api-keys'
      path: '/platform/security/api-keys'
      fullPath: '/platform/security/api-keys'
      preLoaderRoute: typeof PlatformSecurityApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AiCatalogRoute: AiCatalogRoute,
  ApiKeysRoute: ApiKeysRoute,
  BlueprintsRoute: BlueprintsRoute,
  McpsRoute: McpsRoute,
  ProjectsRoute: ProjectsRoute,
  ThemeTokensRoute: ThemeTokensRoute,
  UsageRoute: UsageRoute,
  DeploymentsFastSwitchRoute: DeploymentsFastSwitchRoute,
  DeploymentsNewRoute: DeploymentsNewRoute,
  DeploymentsObservabilityRoute: DeploymentsObservabilityRoute,
  DeploymentsOverviewRoute: DeploymentsOverviewRoute,
  PlaygroundChar123IdChar125Route: PlaygroundChar123IdChar125Route,
  PlatformSecurityApiKeysRoute: PlatformSecurityApiKeysRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
